export const mediaConst = {
  allowExt: ['png'],
} as const;
